import { FormActionType } from '@pages/WindowsCreateOrEdit/types'

import { ACTION_CODE } from '@constants'
import { ActionRow } from '@types'

export const filterActionsByActionCode = (
  actions: ActionRow[] | FormActionType[],
  actionCode: ACTION_CODE
) => {
  return actions.filter(action => action.actionCode === actionCode)
}
